// 📁 stakeholderOverlay.js
export default function showStakeholderOverlay() {
    // Bereits vorhanden? Entfernen
    const existing = document.getElementById('stakeholder-overlay')
    if (existing) existing.remove()

    // Overlay
    const overlay = document.createElement('div')
    overlay.id = 'stakeholder-overlay'
    overlay.style.position = 'fixed'
    overlay.style.top = 0
    overlay.style.left = 0
    overlay.style.width = '100vw'
    overlay.style.height = '100vh'

    overlay.style.display = 'flex'
    overlay.style.justifyContent = 'center'
    overlay.style.alignItems = 'center'
    overlay.style.zIndex = 9999
    overlay.style.animation = 'fadeIn 0.4s ease-out'

    // Box
    const box = document.createElement('div')
    box.style.width = '60vw'
    box.style.maxWidth = '800px'
    box.style.background = '#ffffff'
    box.style.borderRadius = '16px'
    box.style.padding = '30px'
    box.style.textAlign = 'center'
    box.style.boxShadow = '0 0 25px rgba(0,0,0,0.3)'
    box.style.animation = 'popUp 0.4s ease-out'
    box.style.position = 'relative'

    // Miro Logo
    const logo = document.createElement('img')
    logo.src ='images/miro.png'
    logo.alt = 'Miro Logo'
    logo.style.width = '80px'
    logo.style.marginBottom = '20px'
    logo.style.opacity = '0.9'
    box.appendChild(logo)

    // Text 
    const text = document.createElement('p')
    text.style.fontSize = '1.1rem'
    text.style.lineHeight = '1.5'
    text.style.marginBottom = '20px'
    text.innerHTML = `
        Das Bedenken und Einbinden aller Stakeholder ist ein essentieller Aspekt eines jeden Projekts – 
        insbesondere im Change-Management. <br><br>
        Auch wenn diese Wichtigkeit auf den ersten Blick offensichtlich erscheint, zeigt sich bei genauerem Hinsehen, 
        auf wie viele unterschiedliche Gruppen die Einführung einer KI Einfluss haben kann. <br><br>
        👉 <strong>Klicken Sie hier und analysieren Sie Ihre Stakeholder:innen für Ihren Anwendungsfall auf dem Miro Board:</strong>
    `
    box.appendChild(text)

    // Link-Button
    const link = document.createElement('a')
    link.href = 'https://miro.com/app/board/uXjVJWXZKvk=/?share_link_id=390919602386'
    link.target = '_blank'
    link.textContent = '🔗 Miro Board öffnen'
    link.style.display = 'inline-block'
    link.style.padding = '12px 24px'
    link.style.backgroundColor = '#ffd02f'
    link.style.color = '#000000'
    link.style.borderRadius = '8px'
    link.style.textDecoration = 'none'
    link.style.fontWeight = 'bold'
    link.style.transition = 'transform 0.2s ease'
    link.onmouseover = () => link.style.transform = 'scale(1.05)'
    link.onmouseout = () => link.style.transform = 'scale(1)'
    box.appendChild(link)

    // Close Button
    const close = document.createElement('button')
    close.textContent = '✖'
    close.style.position = 'absolute'
    close.style.top = '20px'
    close.style.right = '30px'
    close.style.fontSize = '12px'
    close.style.background = '#f44336'
    close.style.color = '#ffffff'
    close.style.border = 'none'
    close.style.cursor = 'pointer'
    close.onclick = () => overlay.remove()
    box.appendChild(close)
    overlay.appendChild(box)
    document.body.appendChild(overlay)

    // CSS Keyframes
    const style = document.createElement('style')
    style.textContent = `
        @keyframes fadeIn {
            from { opacity: 0 } to { opacity: 1 }
        }
        @keyframes popUp {
            0% { transform: scale(0.8); opacity: 0 }
            100% { transform: scale(1); opacity: 1 }
        }
    `
    document.head.appendChild(style)
}
